module.exports = __webpack_public_path__ + "static/media/EBIPS png.520122d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/EBIPS png.png
// module id = 574
// module chunks = 0